import React, { useRef, useEffect } from 'react'
import p5 from 'p5'

const Sketch = () => {
  const sketchRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const sketch = new p5((p: p5) => {
      let frameCount = 0

      p.setup = () => {
        const canvasWidth = window.innerWidth
        const canvasHeight = window.innerHeight
        p.createCanvas(canvasWidth, canvasHeight, p.WEBGL).parent(
          sketchRef.current!
        )
      }

      p.draw = () => {
        p.background(255)
        p.rotateY(frameCount * 0.001)

        for (let j = 0; j < 5; j++) {
          p.push()
          for (let i = 0; i < 40; i++) {
            p.translate(
              p.cos(frameCount * 0.001 + j) * 100,
              p.tan(frameCount * 0.001 + j) * 100,
              i * 0.1
            )
            p.rotateZ(frameCount * 0.002)
            p.push()
            p.sphere(8, 6, 4)
            p.pop()
          }
          p.pop()
        }

        frameCount++
      }
    })

    return () => {
      sketch.remove()
    }
  }, [])

  return (
    <div className="animation-box">
      <div ref={sketchRef}></div>
    </div>
  )
}

export default Sketch
